const state = {
  orderItems: [],
};

const getters = {
  showCartAmount(state) {
    return state.orderItems.length;
  },
  showCartContent(state) {
    return state.orderItems;
  },
};

const mutations = {
  addOrderItem(state, orderItem) {
    state.orderItems.push(orderItem);
  },
  deleteOrderItem(state, id) {
    state.orderItems = state.orderItems.filter((el) => el.id !== id);
  },
  addQuantity(state, id) {
    state.orderItems.forEach((el) => {
      if (el.id === id) {
        el.quantity + 1;
      }
    });
  },
  substractQuantity(state, id) {
    state.orderItems.forEach((el) => {
      if (el.id === id) {
        el.quantity - 1;
      }
    });
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
